class BookingCartCleaner {
  constructor() {
    this.init();
  }

  async init() {
    const cart = await this.fetchCart();
    const bookingItems = this.getBookingItems(cart);
    if (!bookingItems.length) return;

    await this.removeItems(bookingItems);

    if (window.Shopify?.designMode) return;

    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
    } else {
      this.refreshCartDrawer();
    }
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  getBookingItems(cart) {
    return cart.items.filter(item => item.properties?.booking_date);
  }

  async removeItems(items) {
    const updates = {};
    items.forEach(item => updates[item.key] = 0);

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }

  refreshCartDrawer() {
    const drawer = document.querySelector('cart-drawer-items');
    if (!drawer) return;

    const cartItems = drawer.closest('cart-items') || drawer;
    if (typeof cartItems.updateQuantity !== 'function') return;

    // Re-render by fetching updated section HTML via a no-op update
    const firstInput = drawer.querySelector('[name="updates[]"]');
    if (firstInput) {
      cartItems.updateQuantity(firstInput.dataset.index, firstInput.value);
    } else {
      // Cart is now empty — trigger a re-render with a dummy line update
      fetch(`${routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: 1,
          quantity: 0,
          sections: drawer.getSectionsToRender().map(s => s.section),
          sections_url: window.location.pathname
        })
      })
      .then(r => r.json())
      .then(response => drawer.renderContents(response));
    }
  }
}

new BookingCartCleaner();